/* eslint-disable */
import router from "@/router";
import axios from "axios";
import { toast } from "vue3-toastify";
import { defineStore } from "pinia";
import { useLoading } from "vue-loading-overlay";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    logged_in_user: JSON.parse(localStorage.getItem("loggedInUser")),
    registed_user: null,
    reset_pass_user: null,
    OTP: {
      otp_id: null,
      otp_number: "",
      otp_is_used: false,
      otp_generated_for_usr_id: 0,
      otp_created_on: new Date(),
      otp_status: 1,
      otp_valid_till: null,
    },
    selectedProduct: null,
    listToBeRefresh: null,
    hideMenu: false,
    $loading: useLoading(),
  }),
  getters: {
    isUserLoggedIn: (state) => !state.logged_in_user,
    get_logged_in_user: (state) => state.logged_in_user,
    get_registed_user: (state) => state.registed_user,
  },
  actions: {
    async register(form) {
      let loader = this.$loading.show();
      await axios
        .post("/manage_user", form.value)
        .then((res) => {
          if (
            res.data != null &&
            res.data.user != null &&
            res.data.user.usr_id != null &&
            res.data.user.usr_id > 0
          ) {
            loader.hide();
            this.registed_user = res.data.user;
            this.generateOTP();
          }
        })
        .catch((err) => {
          loader.hide();
          if (err.response.data != undefined && err.response.data != null) {
            toast(err.response.data.detail, {
              autoClose: 2000,
              theme: "colored",
              type: "error",
              position: "bottom-left",
              dangerouslyHTMLString: true,
            });
          }
        });
    },
    async generateOTP() {
      let loader = this.$loading.show();
      this.OTP.otp_generated_for_usr_id = this.registed_user.usr_id;
     await  axios
        .post("/generate_otp", this.OTP)
        .then((res) => {
          if (res.data != null) {
            loader.hide();
            router.push({ name: "verify-otp" });
          }
        })
        .catch((err) => {
          loader.hide();
          //add logic to delete the user if otp generation fails or send email fails
           this.delete_user(this.registed_user);
          toast(err.response.data.detail, {
            autoClose: 2000,
            theme: "colored",
            type: "error",
            position: "bottom-left",
            dangerouslyHTMLString: true,
          });
        });
    },
    async delete_user(user) {
      await axios
        .post("/delete_user/", user )
        .then((res) => {
          this.registed_user = null;
        })
        .catch((err) => {
          console.error("Error deleting user after OTP failure:", err);
        }); 
      },
    
    login(form) {
      const fd_user = new FormData();
      fd_user.append("username", form.value.username);
      fd_user.append("password", form.value.password);

      axios
        .post("/login_user", fd_user)
        .then((res) => {
          this.logged_in_user = res.data;
          localStorage.setItem("loggedInUser", JSON.stringify(res.data));
          router.push({ name: "dashboard" });
        })
        .catch((err) => {
          if (err.response.data != undefined && err.response.data != null) {
            toast(err.response.data.detail, {
              autoClose: 2000,
              theme: "colored",
              type: "error",
              position: "bottom-left",
              dangerouslyHTMLString: true,
            });
          }
        });
    },
    logout() {
      this.logged_in_user = null;
      localStorage.removeItem("loggedInUser");
      router.push({ name: "login" });
    },
    toggleMenuBar() {
      this.hideMenu = !this.hideMenu;
    },
  },
});
